<atn-ds-page>
  <atn-ds-table [config]="usersTableConfig" />
  <atn-admin-user-modal />
</atn-ds-page>

@if (usersEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()) {
  @let deletionError =
    usersEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete User"
    [description]="deleteConfirmationTextSg()"
    [error]="deletionError"
    [validation]="deletingUserNameSg()"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
